<template>
  <input type="checkbox"
         :id="item.mailing_list_id"
         v-model="model" />
</template>

<script>
import formElement from '../mixins/form-element';

export default {
  mixins: [formElement],
  props: ['item', 'checked'],
  computed: {
    model: {
      get() {
        return !!this.checked;
      },
      set(value) {
        this.$emit('change', {
          id: this.item.mailing_list_id,
          value,
        });
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MailingListsCheck.vue